import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=4e9e52b0&"
import script from "./PageCreate.vue?vue&type=script&lang=js&"
export * from "./PageCreate.vue?vue&type=script&lang=js&"
import style0 from "./PageCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports